import { User, Users } from 'lucide-react';

import type {
  GetAllReservations,
  GetAllSecondOpinions,
} from '@virtual-care/client';
import {
  type PatientDemographics,
  displayName,
  toAge,
} from '@virtual-care/isomorphic';

type Patient =
  | GetAllReservations['records'][number]['user']
  | GetAllSecondOpinions['records'][number]['patient'];

interface PatientInfoProps {
  patient: Patient;
  patientDemographics?: PatientDemographics;
}

export function PatientInfo({ patient, patientDemographics }: PatientInfoProps) {
  return (
    <div className="bg-muted/50 rounded-lg p-4">
      <h3 className="mb-3 flex items-center gap-2 font-semibold">
        <User className="h-4 w-4" />
        Patient Information
      </h3>
      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">Name:</span>
          <span className="text-sm">
            {patientDemographics?.name ?? displayName(patient)}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">Phone:</span>
          <span className="text-sm">{patient.phoneNumber}</span>
        </div>
        {(patientDemographics?.birthDate || patient.b2cProfile) && (
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">Age:</span>
            <span className="text-sm">
              {patientDemographics?.birthDate
                ? toAge({ birthDate: patientDemographics.birthDate })
                : patient.b2cProfile
                  ? toAge(patient.b2cProfile)
                  : 'غير محدد'}
            </span>
          </div>
        )}
        {(patientDemographics?.gender || patient.b2cProfile?.gender) && (
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">Gender:</span>
            <span className="text-sm">
              {(() => {
                const g =
                  patientDemographics?.gender ?? patient.b2cProfile?.gender;
                return g === 'male'
                  ? 'Male'
                  : g === 'female'
                    ? 'Female'
                    : '';
              })()}
            </span>
          </div>
        )}
        {patient?.email && (
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">Email:</span>
            <span className="text-sm">{patient.email}</span>
          </div>
        )}
      </div>
      {patientDemographics && (
        <div className="mt-3 border-t pt-3">
          <p className="text-muted-foreground flex items-center gap-1 text-xs">
            <Users className="h-3 w-3" />
            Booked on behalf — account holder: {displayName(patient)}
          </p>
        </div>
      )}
    </div>
  );
}
